import React from 'react';
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { NotificationManager } from "../../components/common/react-notifications";
import _axios from "../../libs/axios";

const TokenDisplay = ({ form, L }) => {
  const token = form.accessToken;
  if (!token) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(token).then(() => {
      NotificationManager.success("Token copied to clipboard", "", 3000, null, null, 'outline');
    }).catch(() => {
      NotificationManager.error("Failed to copy token", "Error", 3000, null, null, 'outline');
    });
  };

  return (
    <div className="form-group">
      <label className="title-field">Access Token</label>
      <InputGroup>
        <Input type="text" value={token} readOnly style={{ backgroundColor: '#f8f9fa' }} />
        <InputGroupAddon addonType="append">
          <Button color="primary" onClick={handleCopy}>
            <i className="simple-icon-docs"></i> Copy
          </Button>
        </InputGroupAddon>
      </InputGroup>
    </div>
  );
};

export default (context) => {
  return {
    config: {
      pageSize: 40,
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    filter:{
      fields: [
        {
          name: "type",
          value: -1,
          type: "select",
          label: "main.type",
          opts: {
            style: 'float-label',
            path: '/admGroup/getTypes'
          }
        }
      ],
      buttons: [
        {
          label: "main.applyFilter",
          renderIf: (ctx) => { return Number.isInteger(ctx.state.type) },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.groupId = r.data.groupId ? { value: r.data.groupId, label: r.data.groupName } : ""
        }
        return r
      },
      setValuesBeforePost: (form) => {
        // Remove groupType - it's read-only and should not be sent in POST
        delete form.groupType;
        return form;
      },
      fields: [
        {
          col: 12,
          name: "groupType",
          value: null,
          type: "hidden"
        },
        {
          col: 6,
          name: "name",
          value: null,
          type: "text",
          label: "main.name",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "last",
          value: null,
          type: "text",
          label: "main.lastName",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "mail",
          value: null,
          type: "text",
          label: "main.email",
          rules: 'required|email',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "cel",
          value: null,
          type: "number",
          label: "main.cellPhone",
          rules: "required|max:13",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "pass",
          value: null,
          type: "password",
          label: "main.password",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "inactive",
          value: false,
          type: "switch",
          label: "main.inactive",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "face",
          value: "",
          type: "dropzone",
          label: "main.photography",
          isDoc: false,
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "/admStaff/file",
            accept: '.jpeg,.jpg,.png',
            output: true
          }
        },
        {
          col: 6,
          name: "sign",
          value: "",
          type: "dropzone",
          label: "main.signature",
          isDoc: false,
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "/admStaff/sign",
            accept: '.jpeg,.jpg,.png',
            output: true
          }
        },
        {
          col: 6,
          name: "notifModes",
          value: null,
          type: "text",
          label: "main.notifyVia",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "externalId",
          value: null,
          type: "text",
          label: "main.externalId",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "groupId",
          value: null,
          type: "select",
          label: "main.group",
          rules: "required",
          opts: {
            style: 'float-label',
            path: 'admGroup/get?staff=1'
          }
        },
        {
          col: 6,
          name: "validSMS",
          value: false,
          type: "switch",
          label: "WhatsApp login",
          renderIf: () => context.state.idItemSelected,
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "sendWelcome",
          value: false,
          type: "switch",
          label: "Send welcome email",
          renderIf: () => context.state.idItemSelected,
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "createTokenBtn",
          value: null,
          type: "button",
          label: "Create access token",
          renderIf: (ctx) => {
            const groupType = ctx.state.groupType;
            if (groupType === undefined || groupType === null) return false;
            return Number(groupType) === 99;
          },
          onClick: (ctx) => {
            context.props.setLoader(true);
            _axios
              .post(`/admStaff/accesstoken/${context.state.idItemSelected}`, {})
              .then(r => {
                context.props.setLoader(false);
                if (r.status >= 0 && r.data) {
                  ctx.setState({ accessToken: r.data });
                  NotificationManager.success(r.msg || "Token created successfully", "", 3000, null, null, 'outline');
                } else {
                  NotificationManager.error(r.msg || "Error creating token", "Opps", 5000, null, null, 'outline');
                }
              })
              .catch(e => {
                context.props.setLoader(false);
              });
          },
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 12,
          name: "accessToken",
          value: null,
          type: "component",
          renderIf: (ctx) => ctx.state.accessToken,
          opts: {
            component: TokenDisplay
          }
        },
      ]
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: "main.lastName",
        accessor: "last"
      },
      {
        Header: "main.cellPhone",
        accessor: "cel"
      },
      {
        Header: "main.email",
        accessor: "mail"
      }
    ]
  }
}